module.exports = {
          srcSet: __webpack_public_path__ + "images/1999-1036383763470c352d6802e0472c2ceb-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1999-d6b201570aba2e900ffa1ccd2c729c25-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1999-1036383763470c352d6802e0472c2ceb-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1999-d6b201570aba2e900ffa1ccd2c729c25-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1999-1036383763470c352d6802e0472c2ceb-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1999-1036383763470c352d6802e0472c2ceb-320.jpg"},
          
          width: 320,
          height: 251
        }